import { render, staticRenderFns } from "./TabChangelog.vue?vue&type=template&id=c060657a&scoped=true&"
import script from "./TabChangelog.vue?vue&type=script&lang=ts&"
export * from "./TabChangelog.vue?vue&type=script&lang=ts&"
import style0 from "./TabChangelog.vue?vue&type=style&index=0&id=c060657a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c060657a",
  null
  
)

export default component.exports